import { useInfiniteQuery } from "react-query"
import RedemptionService from "~services/RedemptionService"

const useUserRedemptions = (userId: string) => {
  return useInfiniteQuery(
    ["user-redemptions", userId],
    ({ pageParam = 0 }) =>
      RedemptionService.getRedemptionsByUser(userId, { pageParam }),
    {
      enabled: false,
      getNextPageParam: (lastPage, allPages) => {
        return lastPage.hasNextPage
      },
    }
  )
}
export default useUserRedemptions
